import { DestroyRef, inject } from '@angular/core';

// Ressource rechargeable (httpResource).
export interface Reloadable {
  reload(): unknown;
  isLoading(): boolean;
}

// Recharge une ressource a intervalle regulier, tant que le contexte d'injection
// (composant) vit. Remplace le temps reel en attendant le lot 10.
export function reloadEvery(resource: Reloadable, intervalMs: number): void {
  const timer = setInterval(() => {
    if (!resource.isLoading()) {
      resource.reload();
    }
  }, intervalMs);
  inject(DestroyRef).onDestroy(() => clearInterval(timer));
}
